import { StaffAffectation } from '../../lib/types/models/affectedStaff/staff-affectation'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const getStaffAffectations = async (id: number) => {
  return restApiClient
    .url(constructApiUrl(API.staffs.getAffectations.url, { id }))
    .get<StaffAffectation[]>()
}
